<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9grDGy/tc-custom/9781439675557.jpg?1684305842706" alt="This image is the cover for the book Historic Orlando, Past and Present"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Historic Orlando, Past and Present
      </h1>
      <p class="bookDescription body article font2">
        <p>Orlando's historic districts are separate throughout the city, yet its landmarks and its memories unite them. Images of Orlando from 1875 to 2022 paint a picture of a landscape dotted with cattle and orange trees exploding into a bustling city. While some authors claim that Orlando's history is lost, these images show how the city's Historic Preservation Board has safeguarded many cultural and architectural treasures.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Randall, Bob Randall
      </h2>
      
      <p class="authorDescription body article">Elizabeth and Bob Randall work together as a photojournalist team and have won awards for their writing and photography. This is their sixth book about Florida.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7273d2bf